<table class="file-metadata-table">
	<tr>
		<th>{{ 'name' | translate }}</th>
		<th>{{ 'format' | translate }}</th>
		<th>{{ 'version' | translate }}</th>
		<th>{{ 'updated' | translate }}</th>
		<th></th>
	</tr>
	<tr>
		<td class="name">{{ fileData.file.name }}</td>
		<td>{{ getFormatFromContentType(fileData.file.contentType) }}</td>
		<td>{{ fileData.version }}</td>
		<td>{{ fileData.updated | dateAgo }}</td>
		<td class="file-action-buttons">
			<button
				mat-fab
				class="action-button mat-fab--p0 au-button-no-shadow"
				matTooltip="{{ 'download_file' | translate }}"
				(click)="$event.stopPropagation(); download($event)"
			>
				<mat-icon class="icon accent-icon" svgIcon="download"></mat-icon>
			</button>

			<button
				mat-fab
				class="action-button mat-fab--p0 au-button-no-shadow"
				matTooltip="{{ 'upload_new_version' | translate }}"
				(click)="$event.stopPropagation(); replace($event)"
			>
				<mat-icon class="icon accent-icon" svgIcon="upgrade">upload</mat-icon>
			</button>
		</td>
	</tr>
</table>
